import { absolutePathWithArrayIndices } from "../absolutePath";
import type { AnalyticsApiParams } from "./types";

export const events = {
  events_completed: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/events_completed", params),
  total_rsvps: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/total_rsvps", params),
  live_attendance: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/live_attendance", params),
  tickets_sold: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/tickets_sold", params),
  event_revenue: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/event_revenue", params),
  popular_times: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/popular_times", params),
  event_activity: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/event_activity", params),
  popular_events: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/popular_events", params),
  top_attendees: (params: AnalyticsApiParams) =>
    absolutePathWithArrayIndices("analytics/events/top_attendees", params),
};
